import React from 'react';
import "./Player.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartPlus } from '@fortawesome/free-solid-svg-icons'
import button from 'react-bootstrap/Button';
import { Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';


const Player = (props) => {
    // console.log(props.addCart)
    const {name,picture,salary}=props.player
    
    return (     
        <div className="playerPart">
            <div className="Player">
                <h4>{name}</h4>
                <img className="playerImg" src={picture} alt="" />
                <p>{salary}</p>
                <Button color="primary" onClick={() => props.addCart(props.player)}> <FontAwesomeIcon icon={faCartPlus} />Add Player</Button>
            </div>
        </div>
        
    );
   
};

export default Player;